import fetcher from "fetcher";
import base from "./base";

let cachedSettings = null;
let cacheTime = 0;
const CACHE_TTL = 60000; // 1 minute

export async function getStoreSettings() {
  const now = Date.now();
  if (cachedSettings && now - cacheTime < CACHE_TTL) {
    return cachedSettings;
  }

  try {
    const result = await fetcher(`${base.apiUrl}/store-settings`);
    cachedSettings = result?.data || {
      showProductStock: true,
      enableAuth: true,
      allowGuestCheckout: false,
      enablePickup: false,
      enableBankTransfer: false,
      allowOrders: true,
      deliveryFee: 0,
    };
    cacheTime = now;
    return cachedSettings;
  } catch (error) {
    console.error("Failed to load store settings:", error);
    // Return default settings on error
    return {
      showProductStock: true,
      enableAuth: true,
      allowGuestCheckout: false,
      enablePickup: false,
      enableBankTransfer: false,
      allowOrders: true,
      deliveryFee: 0,
    };
  }
}
